import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DataTableModule, SharedModule, InputSwitchModule,
    MultiSelectModule, DialogModule, ConfirmDialogModule, TriStateCheckboxModule } from 'primeng/primeng';

import { CadensSharedModule } from '../../shared';
import { CadensAdminModule } from '../../admin/admin.module';
import { LinkUserComponent } from './link-user/link-user.component';

import {
    FormationService,
    FormationPopupService,
    FormationComponent,
    FormationDetailComponent,
    FormationDeletePopupComponent,
    FormationDeleteDialogComponent,
    formationRoute,
    formationPopupRoute,
    CategorieFormationService,
    PieceService,
    QuestionService,
    FormationNewDialogComponent,
    FormationNewPopupComponent
} from './';
import {CadensBlocksModule} from '../blocks/blocks.module';
import {ReactiveFormsModule} from '@angular/forms';

let ENTITY_STATES = [
    ...formationRoute,
    ...formationPopupRoute,
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        DataTableModule, SharedModule, InputSwitchModule,
        MultiSelectModule,
        DialogModule,
        CadensBlocksModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        RouterModule.forRoot(ENTITY_STATES, {useHash: true}), TriStateCheckboxModule
    ],
    declarations: [
        FormationComponent,
        FormationDetailComponent,
        FormationDeleteDialogComponent,
        FormationDeletePopupComponent,
        FormationNewDialogComponent,
        FormationNewPopupComponent,
        LinkUserComponent
    ],
    entryComponents: [
        FormationComponent,
        FormationDeleteDialogComponent,
        FormationDeletePopupComponent,
        FormationNewDialogComponent,
        FormationNewPopupComponent
    ],
    providers: [
        FormationService,
        FormationPopupService,
        CategorieFormationService,
        PieceService,
        QuestionService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensFormationModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation.module.ts